import { Stack } from '@mantine/core';
import type { ProviderConfigField } from '@bmai/shared';
import type { ProviderOption } from '../IntegrationsService';
import { renderField } from './renderField';
import { useDefaultValueTemplates } from './useDefaultValueTemplates';

interface Props {
    fields: ProviderConfigField[];
    config: Record<string, unknown>;
    editing: boolean;
    onFieldChange: (name: string, value: unknown) => void;
    onLoadOptions: (route: string) => Promise<ProviderOption[]>;
}

/** Renders a flat list of provider-config fields. Reused for preAuthConfig and config steps. */
export default function ConnectionStepFields({
    fields,
    config,
    editing,
    onFieldChange,
    onLoadOptions,
}: Props): React.ReactElement {
    const secretPlaceholder = editing ? '••••••••  (leave blank to keep existing)' : undefined;
    const displayConfig = useDefaultValueTemplates(fields, config, onFieldChange);
    return (
        <Stack>
            {fields.map((f) =>
                renderField({
                    field: f,
                    value: displayConfig[f.name],
                    onChange: (v) => onFieldChange(f.name, v),
                    secretPlaceholder,
                    onLoadOptions,
                }),
            )}
        </Stack>
    );
}
